import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'
import { FaWhatsapp } from 'react-icons/fa'

const WhatsApp: FC<IconProps> = (props) => <Icon as={FaWhatsapp} fontSize="24px" color="brand.100" {...props} />

export default WhatsApp
